<template>
  <div class="sign">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="deliveryOrdeNo"
          placeholder="WMS单号,RQD开头"
          right-icon="scan"
          @click-right-icon="scanCode"
          @keyup.13="getList()"
        />
        <van-field
          size="small"
          v-model="orgCustomerNo"
          placeholder="其他单号"
          :formatter="relationNumberFmt"
          right-icon="scan"
          @click-right-icon="scanOrg"
          @keyup.13="getList()"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList()">查询</button>
      </div>
    </div>

    <div class="mobileHeader">
      <template v-if="showDetail">
        <div>
          进仓单号：<span class="docLight">{{ dataModel.deliveryOrdeNo }}</span>
        </div>
        <div>
          参考单号：<span class="docLight">{{ dataModel.orgCustomerNo }}</span>
        </div>
        <div>
          货主代码：<span class="docLight">{{ dataModel.ownerCode }}</span>
        </div>
        <div>
          客户名称：<span class="docLight">{{ dataModel.customName }}</span>
        </div>
        <div>
          货物品名：<span class="docLight">{{ dataModel.declareCName }}</span>
        </div>
        <div>
          库存状态：<span class="docLight">{{ dataModel.stockStatus }}</span>
        </div>
        <div class="boxNumber">
          <span>
            箱数：<span>{{ dataModel.totalBoxCount }}</span>
          </span>
          <span>总KG：{{ dataModel.totalGrossWeight }}</span>
          <span>总CBM：{{ dataModel.totalVolume }}</span>
        </div>
        <div>
          <i class="el-icon-user-solid elIcon"></i
          ><span class="actualCheck">实收：</span>
        </div>
        <div class="boxNumber">
          <span>
            箱数：<span class="actualCheck">{{
              dataModel.actualBoxCount
            }}</span>
          </span>
          <span>
            总KG：<span class="actualCheck">{{ dataModel.actualWeight }}</span>
          </span>
          <span>
            总CBM：<span class="actualCheck">{{ dataModel.actualVolumn }}</span>
          </span>
        </div>
        <div>
          入仓时间：<span class="docLight">{{ dataModel.putOnDate }}</span>
          <!-- <el-button class="btn" icon="el-icon-edit" style="float: right" @click="recheck()">
            复测
          </el-button> -->
          <el-button
            type="primary"
            icon="el-icon-edit"
            style="float: right"
            @click="recheck()"
            >复测</el-button
          >
        </div>
        <div>
          上架人员：<span class="docLight">{{ dataModel.putOnUser }}</span>
        </div>
        <div>
          收货卡板：<span class="docLight">{{ dataModel.palletQty }} 托</span>
          <el-button v-if="dataModel.palletQty<=0"
            type="primary"
            icon="el-icon-edit"
            style="float: right"
            @click="editPallet()"
            >维护</el-button>
            <el-button v-if="dataModel.palletQty>0"
            type="primary"
            icon="el-icon-printer"
            style="float: right"
            @click="printPallet()"
            >打印</el-button>
        </div>
        <div>
          在库箱数：<span class="docLight"
            >{{ dataModel.inStockBoxQty }} 箱</span
          >
        </div>
        <div>
          库位明细：<span class="docLight">{{ dataModel.storages }}</span>
        </div>
        <div>
          入库备注：<span class="docLight">{{ dataModel.remark }}</span>
        </div>
        <div>
          增值服务：<span class="docImport">{{
            dataModel.addServiceInfo
          }}</span>

          <el-button
            type="primary"
            icon="el-icon-edit"
            style="float: right"
            @click="toAddServiceDetail()"
            >操作</el-button
          >
        </div>
      </template>
      <template v-else>
        <van-empty image="search" description="暂无数据" />
      </template>
    </div>
    <van-dialog
      v-model="show"
      :lock-scroll="false"
      class="signInDetail-dalog"
      :title="`复测 ${dataModel.deliveryOrdeNo}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirm"
      :before-close="beforeClose"
    >
    <div class="signInDetail-content">
      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info1"
        :key="index"
      >
        <ul>
          <li class="singleBoxLi">
            <div>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                width="50px"
                placeholder="输入长(cm)"
              />
            </div>
            <div>
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                placeholder="输入宽(cm)"
              />
            </div>
            <div>
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                placeholder="输入高(cm)"
              />
            </div>
          </li>
          <li class="singleBoxLi">
            <div>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWeight"
                placeholder="请输入毛重(kg)"
              />
            </div>
            <div>
              <span>{{ item.inStockSKUCode }}</span>
            </div>
            <span hidden>{{ item.boxInfoIDs }}</span>
          </li>
        </ul>
        <div class="barcodeMethodClass"></div>
      </div>
      <div class="cangku">
        <van-radio-group v-model="recheckType" direction="horizontal">
          <van-radio name="1" shape="square" icon-size="14px"
            >仓库责任</van-radio
          >
          <van-radio name="2" shape="square" icon-size="14px"
            >货主要求</van-radio
          >
        </van-radio-group>
      </div>
    </div>
    </van-dialog>

    <van-action-sheet
      v-model="showActionSheetForPrint"
      :actions="actionsForPrint"
      closeable
      :lazy-render="false"
      cancel-text="取消"
      description="请先选择打印机"
      @select="actionSheetSelectForPrint"
    />

    <van-dialog
      v-model="showPallet"
      :title="`托盘 ${dataModel.deliveryOrdeNo}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirmPallet"
      :before-close="beforeClosePallet"
    >
      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in infoPallet"
        :key="index"
      >
        <ul>
          <li>
            <p class="p-title">{{ item.partCode }}</p>
          </li>
          <li class="singleBoxLi">
            <span>托盘</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.palletQty"
              placeholder=""
            />
            <span>X箱数</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxQty"
              placeholder=""
            />
            <span>尾托箱</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.tailBoxQty"
              placeholder=""
            />
          </li>
        </ul>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Dialog,
  ActionSheet,
  Radio,
  RadioGroup,
} from "vant";
import { getList, recheck,editPalletSubmit } from "@/api/mobile/jy-fastSearch_api";
import { mapState } from "vuex";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";
import { PrintPallet } from "@/api/mobile/bale_api.js";
import { mixins } from "../mobileMixins";
export default {
  data() {
    return {
      showPicker: false,
      isSetPrinter:false,
      showActionSheetForPrint:false,
      actionsForPrint:[],
      printSuccess:false,
      value: "",
      columns: [],
      deliveryOrdeNo: "",
      orgCustomerNo: "",
      showDetail: false,
      dataModel: {},
      customerList: [],
      loading: false,
      finished: false,
      isReadonly: false,
      show: false,
      showPallet: false,
      recheckType: 0,
      info1: [
        {
          sku: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          boxInfoIDs: [],
        },
      ],
      infoPallet: [
        {
          skuCode: "",
          palletQty: "",
          boxQty: "",
          tailBoxQty: "",
        },
      ],
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [ActionSheet.name]: ActionSheet,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },

  mixins: [mixins],

  created() {},

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  methods: {
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    init() {},
    recheck() {
      this.show = true;
    },
    editPallet() {
      if(this.dataModel.palletQty>0)
      {
        this.showsound(false);
        Toast("已有托盘数据,不允许二次维护");
        return;
      }
      this.showPallet = true;
    },
    printPallet() {
      console.info(this.dataModel.warehouseID);
      this.toGetPrinterByUser(this.dataModel.warehouseID);
    },
    actionSheetSelectForPrint(act, i) {
      this.toAddUserPrinter(act.id);
      this.showActionSheetForPrint = false;
    },
    // 新增打印机
    toAddUserPrinter(id) {
      const data = {
        moduleType: 45, // 托唛
        printerInfoID: id,
      };
      AddUserPrinter(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200) {
          this.isSetPrinter = true;
          Toast.success(msg || "添加打印机成功");
        } else {
          Toast(msg);
        }
      });
    },
    // 查询用户是否设置打印机123
    toGetPrinterByUser(warehouseID) {
      const data = {
        moduleType: 45, // 托唛
        wareId: warehouseID,
      };
      this.isSetPrinter = false;
      this.actionsForPrint = [];

      GetPrinterByUser(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200 && response.length) {
          this.showActionSheetForPrint = true;
          Toast("请选择打印机");
          response.forEach((item, i) => {
            this.actionsForPrint.push({
              name: item.printerName,
              id: item.printerInfoID,
            });
            console.log(this.actionsForPrint);
          });
        } else if (status === -100) {
          Toast(msg);
        }
        if (status === 200 && response === 0) {
          this.isSetPrinter = true;
          this.printpalletinfo();
        }
      });
      console.log("显示打印机" + this.isSetPrinter);
    },
    printpalletinfo() {
      this.printSuccess = false;
      const data = {
        sourceID: this.dataModel.tfSignForID,
        sourceType: 45,
        wareID: this.dataModel.warehouseID,
      };
      console.info(data);
      PrintPallet(data).then((res) => {
        Toast.clear();
        if (res.success) {
          this.jsonpPrint(res.response);
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    jsonpPrint(url) {
      Toast.loading({
        message: "打印中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      console.log('打印机地址是:'+url);

      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          Toast.clear();
          Toast.success("打印成功");
          // 更新状态
          this.printSuccess = true;
        })
        .catch((err) => {
          Toast.fail("打印失败");
          console.log("err", err); //请求失败
          Toast.clear();
          if (err.status === 0 || err.status===500) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
            Toast.success("打印成功");
          } else {
            Toast.fail("打印失败");
          }
        });
    },
    scanCode() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.deliveryOrdeNo = a.resultStr;
          that.getList();
        },
      });
    },
    scanOrg() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.orgCustomerNo = a.resultStr;
          that.getList();
        },
      });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.recheckType === 0) {
          this.showsound(false);
          Toast("请勾选复测类型");
          return done(false);
        } else {
          let boxguiempty = false;
          this.info1.forEach((item, i) => {
            if (
              !item.boxLength ||
              !item.boxWidth ||
              !item.boxHeight ||
              !item.boxWeight
            ) {
              boxguiempty = true;
            }
          });
          if (boxguiempty) {
            this.showsound(false);
            Toast("箱规信息有空白,请确认");
            return done(false);
          } else {
            return done();
          }
        }
      } else {
        return done();
      }
    },
    confirm() {
      let isCheck = true;
      const data = [];
      this.info1.forEach((item, i) => {
        data.push(item);
        if (
          !item.boxLength ||
          !item.boxWidth ||
          !item.boxHeight ||
          !item.boxWeight
        ) {
          isCheck = false;
        }
      });
      const dataPara = {
        TFDeliveryOrderID: this.dataModel.tfDeliveryOrderID,
        RecheckType: this.recheckType,
        BoxGui: data,
      };
      if (this.recheckType > 0 && isCheck) {
        recheck(dataPara).then((res) => {
          Toast(res.msg);
          if (res.success) {
            this.showsound(true);
            this.checkMsg = "";
            setTimeout(() => {
              this.getList();
            }, 1000);
          } else {
            this.showsound(false);
            this.checkMsg;
          }
        });
      }
    },
    confirmPallet() {
      let isHaveval = false;
      this.infoPallet.forEach((item, i) => {
        if (item.palletQty > 0 && item.boxQty > 0) {
          isHaveval = true;
        } else {
          if (item.palletQty == 0 || item.boxQty == 0) {
            isHaveval = false;
          }
        }
      });
      if (isHaveval) {
        const dataPara = {
          TFDeliveryOrderID: this.dataModel.tfDeliveryOrderID,
          Pallet: this.infoPallet,
        };
        editPalletSubmit(dataPara).then((res) => {
          Toast(res.msg);
          if (res.success) {
          this.showsound(true);
            this.checkMsg = "";
            setTimeout(() => {
              this.getList();
            }, 1000);
          } else {
            this.showsound(false);
            this.checkMsg;
          }
        });
      }
    },
    beforeClosePallet(action, done) {
      if (action === "confirm") {
        let isHaveval = false;
        this.infoPallet.forEach((item, i) => {
          if (item.palletQty > 0 && item.boxQty > 0) {
            isHaveval = true;
          } else {
            if (item.palletQty == 0 || item.boxQty == 0) {
              isHaveval = false;
            }
          }
        });
        if (!isHaveval) {
          this.showsound(false);
          Toast("托盘填写异常,请确认");
          return done(false);
        } else {
          return done();
        }
      } else {
        return done();
      }
    },
    getList() {
      if (this.deliveryOrdeNo == "" && this.orgCustomerNo == "") {
        this.showsound(false);
        Toast("请输入单号查询");
        return;
      }
      const data = {
        deliveryOrdeNo: this.deliveryOrdeNo,
        orgCustomerNo: this.orgCustomerNo,
      };
      Toast.loading({
        message: "查询中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      getList(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.dataModel = res.response;
          this.info1 = res.response.boxGui;
          this.infoPallet = res.response.pallets;
          console.info(this.infoPallet);
          this.showDetail = true;
        } else {
          this.showsound(false);
          Toast("暂无匹配数据");
          this.showDetail = false;
        }
      });
    },

    toAddServiceDetail() {
      if (this.dataModel.addServiceInfo.includes("未完成")) {
        this.$router.push({
          path: "/mobile/jy-valueAddedServices",
          query: { relationNumber: this.dataModel.deliveryOrdeNo },
        });
      } else {
        this.showsound(false);
        Toast("无需操作增值服务");
      }
    },
    relationNumberFmt(v) {
      return v.trim();
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.mobileHeader {
  padding: 0 10px 3px 15px;
  font-size: 17px;
  font-family: "Source Han Sans", "Noto Sans SC", sans-serif;
  //border-bottom: 1px solid #ccc;
}
.mobileHeader div {
  margin-top: 8px;
}
.cangku {
  padding: 15px 10px;
  .van-radio-group--horizontal {
    justify-content: flex-end;
  }
}
.boxNumber {
  display: flex;
  > span {
    flex: 0.35;
  }
  > span:first-child {
    flex: 0.3;
  }
  > span:last-child {
    flex: 0.35;
  }
}
.signInDetail-btnBox {
  background-color: #fbf9fe;
  padding: 10px;
  overflow: auto; /* 如果内容超出，添加滚动条 */
  border-bottom: 1px solid #cccccc;
  li {
    white-space: nowrap;
    display: flex;
    align-items: baseline;
  }
  .volume {
    min-width: 10%;
    max-width: 27%;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    border: 0;
    background-color: #fbf9fe;
    border-bottom: 1px solid #757474;
    outline: none;
    margin: 0 5px;
    padding: 0 5px;
    box-sizing: border-box;
  }
  &:last-child {
    border-bottom: 0;
  }
}
.btn {
  width: 25%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  height: 25px;
  margin-top: 0px;
}
.elIcon {
  font-size: 26px;
  vertical-align: middle;
}
.docLight {
  color: #42a902;
}
.actualCheck {
  color: #0d7ced;
}
.docImport {
  color: #c90e43;
}
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.sign {
  background-color: #fbf9fe;
}
.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}
.sign-search .btn-box {
  flex: 0.6;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 80px;
}
.sign-toSearch {
  width: 100%;
  height: 94%;
  min-height: 80px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}
.toSearch-box {
  vertical-align: top;
}
.sign-item {
  border-top: 1px solid #ccc;
}
.sign-item li {
  border-bottom: 1px solid #ccc;
  background-color: #fbf9fe;
  padding: 3px 10px;
  font-size: 12px;
}
.sign-list {
  display: flex;
  p {
    flex: 1;
    word-break: break-all;
    margin: 5px 0;
  }
}
.el-button--medium {
  padding: 10px 20px;
  margin: -5px 0px;
  font-size: 14px;
  height: 30px;
  border-radius: 4px;
}
.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  & > div {
    flex: 1;
    text-align: center;
  }
}
.singleBoxLi {
  padding: 10px 0;
  > div:nth-child(2) {
    margin-left: 4px;
    margin-right: 4px;
  }
  > div {
    width: 33.333%;
    display: flex;
    > :last-child {
      flex: 1;
    }
    > span:first-child {
    }
    .volume {
      max-width: initial !important;
      flex: 1;
    }
  }
}
</style>


<style>
.signInDetail-dalog {
  top: 50%;
}
.signInDetail-dalog .signInDetail-content {
  max-height: 80vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>